<template>
  <div class="container" v-change-title="($route.meta.title = activityTitle)">
    <div class="head">
      <div class="video-img" v-if="!bPlaying">
        <div class="video-play" @click="handlePlay" v-if="hasPlayer"><van-icon name="play" /></div>
        <img :src="defaultImg" class="default-img" alt="" />
      </div>
      <div id="polyv" class="video" ref="video"></div>
    </div>
    <div class="main">
      <div class="main-container main-head">
        <p class="title">{{ activityTitle }}</p>
        <p class="main-date">{{ activityDate }}</p>
        <div class="main-head-label">
          <span class="s1">剩余</span>
          <span class="s2">{{ activityRemainNum }}</span>
          <span class="s1">个名额</span>
        </div>
        <div class="count-down">
          <van-count-down :time="countDownTime">
            <template v-slot="timeData">
              <span>距报名结束还剩</span>
              <span class="bg">{{ timeData.days | formtTime }}</span>
              <span>天</span>
              <span class="bg">{{ timeData.hours | formtTime }}</span>
              <span>:</span>
              <span class="bg">{{ timeData.minutes | formtTime }}</span>
              <span>:</span>
              <span class="bg">{{ timeData.seconds | formtTime }}</span>
            </template>
          </van-count-down>
        </div>
      </div>
      <div class="main-full-container">
        <div ref="tab" class="tab">
          <van-sticky @scroll="tabScroll">
            <ul class="tab-nav" :style="{ paddingTop: isFixed ? '30px' : '0px' }">
              <template v-for="(item, index) in tabList">
                <li
                  v-if="
                    (item.type == 1 && (highLights.length > 0 || suitable.length > 0)) ||
                      (item.type == 2 && classOutlineFormt['days'] > 1) ||
                      (item.type == 3 && teacherList)
                  "
                  :key="index"
                  v-anchor="{ target: '#section_' + item.type }"
                  :class="{ active: tabList_active == item.type }"
                  @click="handleClickTab(item.type)"
                >
                  <a href="javascript:void(0);">{{ item.name }}</a>
                  <span></span>
                </li>
              </template>
            </ul>
          </van-sticky>
        </div>
      </div>
      <div class="main-container">
        <div ref="sectionConent" class="tab-content">
          <section v-for="(item, index) in tabList" :key="index" :id="'section_' + item.type">
            <section-jianjie-liangdian
              :list="highLights"
              v-if="item.type == 1 && highLights.length > 0"
            ></section-jianjie-liangdian>
            <section-jianjie-renqun
              :list="suitable"
              v-if="item.type == 1 && suitable.length > 0"
            ></section-jianjie-renqun>
            <section-jianjie-dagang
              :list="classOutlineFormt"
              v-if="item.type == 2 && classOutlineFormt['days'] > 1"
            ></section-jianjie-dagang>
            <section-jianjie-zhujiang
              :teacherList="teacherList"
              v-if="item.type == 3 && teacherList[0]"
            ></section-jianjie-zhujiang>
          </section>
        </div>
      </div>
    </div>
    <com-footer
      :current_price="currentPrice"
      :original_price="originalPrice"
      :status="footerStatus"
      @handleClick_freeGet="freeGet"
    >
    </com-footer>
  </div>
</template>
<script>
import sectionJianjieLiangdian from './components/section_jianjie_liangdian/index';
import sectionJianjieRenqun from './components/section_jianjie_renqun/index';
import sectionJianjieDagang from './components/section_jianjie_dagang/index';
import sectionJianjieZhujiang from './components/section_jianjie_zhujiang/index';
import comFooter from './components/footer/index';
import { debounce, eachRight } from 'lodash-es';
import { Dialog } from 'vant';
import api from '../_api';
import moment from 'moment';
//import kmfSensors from "kmf-sensors";

import { isIos, isAndroid, delObj, setCookies, getCookies } from '@/utils/utils.js';
let format_product_line = {
  4: 'toefl50',
  6: 'toefl6',
  10: 'toefl1',
  3: 'gre50',
  7: 'gre6',
  11: 'gre1',
  5: 'ielts50',
  8: 'ielts6',
  12: 'ielts1',
  1: 'gmat50',
  9: 'gmat6',
  13: 'gmat1'
};
export default {
  components: {
    sectionJianjieLiangdian,
    sectionJianjieRenqun,
    sectionJianjieDagang,
    sectionJianjieZhujiang,
    comFooter
  },
  computed: {
    footerStatus() {
      if (
        this.activityInfo == null ||
        (this.activityInfo && this.activityInfo.list && this.activityInfo.list.length == 0) ||
        this.countDownTime <= 0
      ) {
        return {
          show: false,
          des: '活动已结束'
        };
      } else {
        let nowTime = new Date().getTime() / 1000;
        let endTime = this.checkInfo() && this.activityInfo ? this.activityInfo.list[0].apply_end_time : 0;
        let startTime = this.checkInfo() && this.activityInfo ? this.activityInfo.list[0].apply_start_time : 0;
        //活动未开始
        if (startTime - nowTime > 0) {
          return {
            show: false,
            des: '活动未开始'
          };
        } else {
          //活动已满
          if (this.activityRemainNum == 0) {
            return {
              show: false,
              des: '活动已满'
            };
          } else {
            if (this.hasGet) {
              return {
                show: false,
                des: '已报名'
              };
            } else {
              return {
                show: true,
                des: '立即报名'
              };
            }
          }
        }
      }
    },
    //活动标题
    activityTitle() {
      if (this.checkInfo()) {
        return this.activityInfo ? this.activityInfo.list[0].title : '';
      } else {
        return '';
      }
    },
    //活动剩余名额
    activityRemainNum() {
      if (this.checkInfo()) {
        let _num = this.activityInfo ? this.activityInfo.list[0].buy_limit - this.activityInfo.list[0].buy_num : 0;
        return _num >= 0 ? _num : 0;
      } else {
        return 0;
      }
    },
    //倒计时
    countDownTime() {
      if (this.checkInfo()) {
        let nowTime = new Date().getTime() / 1000;
        let _time = this.activityInfo ? this.activityInfo.list[0].apply_end_time - nowTime : 0;
        return _time > 0 ? _time * 1000 : 0;
      } else {
        return 0;
      }
    },
    //课程亮点
    highLights() {
      if (this.checkInfo()) {
        return this.activityInfo ? [...this.activityInfo.list[0].introduction.high_lights] : [];
      } else {
        return [];
      }
    },
    //适合人群
    suitable() {
      if (this.checkInfo()) {
        return this.activityInfo ? [...this.activityInfo.list[0].introduction.suitable_for] : [];
      } else {
        return [];
      }
    },
    //课程大纲
    classOutlineFormt() {
      let obj = {
        day: {},
        days: 0
      };
      if (!this.classOutline) return obj;
      this.classOutline.sort((a, b) => {
        return a.day < b.day;
      });
      this.classOutline.forEach((item, index) => {
        if (obj['day'][item.day]) {
          obj['day'][item.day].push(item);
        } else {
          obj['days'] += 1;
          obj['day'][item.day] = [];
          obj['day'][item.day].push(item);
        }
      });
      return obj;
    },
    // 讲师信息
    teacherList() {
      let { teachers } = this.activityInfo || {};
      let teachersArr = [];

      if (this.checkInfo()) {
        if (this.type(teachers) == 'Array') return teachers;
        if (this.type(teachers) == 'Object') {
          for (let item in teachers) {
            teachersArr.push(teachers[item]);
          }
          return teachersArr;
        }
      } else {
        return [];
      }
    },
    //当前价格
    currentPrice() {
      if (this.checkInfo()) {
        return this.activityInfo ? this.activityInfo.list[0].current_price : 0;
      } else {
        return 0;
      }
    },
    //原价
    originalPrice() {
      if (this.checkInfo()) {
        return this.activityInfo ? this.activityInfo.list[0].original_price : 0;
      } else {
        return 0;
      }
    },
    businessLine() {
      if (this.checkInfo()) {
        return this.activityInfo ? this.activityInfo.list[0].product_line : '';
      } else {
        return '';
      }
    },
    //背景图片
    videoImg() {
      let { list } = this.activityInfo || {};
      let listData = list ? list[0] : {};
      let { introduction } = listData;
      let { videos } = introduction || {};
      let { face_url } = videos ? videos[0] : '';
      return face_url;
    },
    // 宣传视频地址
    videoSrc() {
      let { list } = this.activityInfo || {};
      let listData = list ? list[0] : {};
      let { introduction } = listData;
      let { videos } = introduction || {};
      let { url } = videos ? videos[0] : '';
      return url;
    },
    // 活动时间
    activityDate() {
      let { list } = this.activityInfo || {};
      let listData = list ? list[0] : {};
      let { start_time, end_time } = listData;

      return start_time
        ? `${moment(start_time * 1000).format('YYYY.MM.DD')} ~ ${moment(end_time * 1000).format('YYYY.MM.DD')}`
        : '';
    }
  },
  data: () => {
    return {
      showLoading: true,
      isFixed: false,
      tabList_active: 1,
      tabList: [{ name: '课程简介', type: 1 }, { name: '课程大纲', type: 2 }, { name: '主讲老师', type: 3 }],
      classOutline: [], //  课程大纲
      _scrollInit: null,
      hasGet: false, //是否参加过活动
      activityInfo: null,
      query: {
        authorization: 0,
        activity_id: '',
        weixin: '',
        idea_id: '',
        idea_time: '',
        cc_pid: '',
        task_id: '',
        cc_group_id: '',
        product_line: 0
      },
      bPlaying: false,
      hasPlayer: false,
      defaultImg: ''
    };
  },
  methods: {
    handlePlay() {
      console.log('player: ', this.player);
      this.player.j2s_playVideo();
      this.bPlaying = true;
    },
    async kmfSensorsInit() {
      let pid;
      if (!getCookies('authkey')) {
        pid = 0;
      } else {
        let result = await this.getPassportId();
        if (result.status == 200) {
          let { id } = result.result;
          pid = id;
        } else {
          pid = 0;
        }
      }
      this.$kmfSensors.init({
        pid: pid,
        params: {
          project: 'ielts',
          platform: isIos() ? 'ios' : 'android',
          product_line: this.query.product_line
        }
      });
    },
    tabScroll(even) {
      // this.isFixed=even.isFixed;
    },
    async freeGet() {
      if (!getCookies('authkey')) {
        this.$toast({
          message: '请先登录',
          onClose: () => {
            this.goLogin();
          }
        });
        return;
      }
      if (window.kmfSensors) {
        if (this.query.idea_id) {
          window.kmfSensors.track('signUpClickEvent', {
            activity_id: this.query.activity_id,
            idea_id: this.query.idea_id,
            product: 'ielts',
            platform: isIos() ? 'ios' : 'android',
            product_line: this.query.product_line
          });
        } else {
          window.kmfSensors.track('signUpTEClickEvent', {
            activity_id: this.query.activity_id,
            product: 'ielts',
            platform: isIos() ? 'ios' : 'android',
            product_line: this.query.product_line
          });
        }
      }
      this.checkCrmResourcesStatus().then(res => {
        if (res.status == 200) {
          if (res.result == null || !res.result.hasContact) {
            let params = {
              teacherImg: this.teacherImg,
              title: this.activityTitle,
              price: this.currentPrice,
              business_line: this.businessLine,
              shop_tag: this.activityInfo ? this.activityInfo['list'][0]['shop_tag'] : '',
              goods_id: this.activityInfo ? this.activityInfo['list'][0]['goods_id'] : ''
            };
            let weixin = res.result.weChats ? res.result.weChats[0] || '' : '';
            let _params = Object.assign({}, params, this.query, {
              weixin: weixin
            });
            this.$router.push({
              path: '/common-web/submitOrder',
              query: _params
            });
          }
          if (res.result && res.result.hasContact) {
            this.ajaxFreeGet(res.result.weChats ? res.result.weChats[0] || '' : '');
          }
        }
      });
    },
    //获取免费课
    ajaxFreeGet(weixin) {
      if (this.activityInfo && this.activityInfo['list'][0]['shop_tag'] == 2) {
        this.$toast('活动配置无效，无法报名!');
        return;
      }
      let data = Object.assign({}, this.query);
      data = delObj(Object.assign({}, data, { weixin: weixin }), ['product_line']);
      this.$http.post(api.apply, data).then(res => {
        if (res.result.error_code == 200) {
          if (this.activityInfo && this.activityInfo['list'][0]['shop_tag'] == 0) {
            this.hasGet = true;
            this.$toast.success({
              message: '报名成功!',
              onClose: () => {
                this.goClass();
              }
            });
          } else if (this.activityInfo && this.activityInfo['list'][0]['shop_tag'] == 1) {
            let originUrl = window.location.href;
            setCookies('common-payBridge', originUrl);
            let goodsArr = [];
            goodsArr.push({
              number: 1,
              goods_id: this.activityInfo['list'][0].goods_id
            });
            window.location.href = `${process.env.VUE_APP_PRFIEX}shop.kmf.com/shop/#/buy?items=${JSON.stringify(
              goodsArr
            )}`;
          }
        } else {
          this.$toast.fail(res.result.error_msg);
        }
      });
    },
    //进入课程
    goClass() {
      if (isIos()) {
        window.webkit.messageHandlers.nativeGoClass.postMessage(null);
      }
      if (isAndroid()) {
        window.app.nativeGoClass();
      }
    },
    //去登陆
    goLogin() {
      if (isIos()) {
        window.webkit.messageHandlers.nativeLogin.postMessage(null);
      }
      if (isAndroid()) {
        window.app.nativeLogin();
      }
    },
    getPassportId() {
      return this.$http.get(api.getPassport, {
        headers: {
          'K-Idfa-Imei': '',
          /* 'K-Product-Line': '',
          'K-Platform': '' */
        }
      });
    },
    //查看是否已建联，是直接购买跳转购买成功，不是跳转填写微信号订单页面
    checkCrmResourcesStatus() {
      return this.$http.get(api.getSellerInfo, {
        params: {
          // passport_id: id,
          /* site: this.businessLine,
          activity_id: this.query.activity_id */
          business_line: this.businessLine,
          source: 1,
          sole: 1
        }
      });
    },
    checkInfo() {
      return this.activityInfo && this.activityInfo.list.length > 0 ? true : false;
    },
    handleClickTab(type) {
      this.unbindScroll();
      this.tabList_active = type;
      setTimeout(() => {
        this.bindScroll();
      }, 400);
    },
    scrollInit(event) {
      let scroll = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
      let sectionList = this.$refs.sectionConent.children;
      let _index = 0;
      eachRight(sectionList, (item, index) => {
        if (scroll >= item.offsetTop) {
          _index = index;
          return false;
        }
      });
      this.tabList_active = this.tabList[_index].type;
    },
    bindScroll() {
      window.addEventListener('scroll', this._scrollInit, false);
    },
    unbindScroll() {
      window.removeEventListener('scroll', this._scrollInit, false);
    },
    // 获取活动信息
    getActivityInfo() {
      this.$http
        .get(api.getHdList, {
          params: {
            activity_ids: this.query.activity_id
          }
        })
        .then(res => {
          if (res.status == 200) {
            if (res.result.list.length == 0) {
              Dialog.alert({
                title: '提示!',
                message: '活动已经结束'
              }).then(() => {
                // on close
              });
              return;
            } else {
              this.activityInfo = res.result;
              let { list } = this.activityInfo;
              let { product_line, introduction } = list[0] || {};
              let { videos } = introduction || {};
              let { url, face_url } = videos ? videos[0] : '';

              this.defaultImg = face_url;
              this.query.product_line = product_line;

              console.log('activityInfo: ', this.activityInfo);
              // 初始化保利威视功能
              this.getPolyvInfo(url);
            }
          }
        });
    },
    // 获取课程大纲
    getClassOutline() {
      this.$http
        .get(api.getHdTasks, {
          params: {
            activity_ids: this.query.activity_id
          },
          headers: {
            'K-Version': 'v2'
          }
        })
        .then(res => {
          if (res.status == 200) {
            this.classOutline = res.result.list[this.query.activity_id];
          }
        });
    },
    // 获取活动参与状态
    getParticipateStatus(cb) {
      this.$http.get(`${api.getHasGet}/${this.query.activity_id}`).then(res => {
        if (res.result.enroll.apply_status == 1 || res.apply_status == 2) {
          this.hasGet = true;
        } else {
          this.hasGet = false;
        }
        if (cb) cb();
      });
    },
    // 获取保利威视数据
    getPolyvInfo(polyv_id) {
      this.$http
        .get(api.getPolyvInfo, {
          params: {
            polyv_id
          }
        })
        .then(res => {
          let { status, result, message } = res;
          if (status == 200) {
            let { ts, vid, sign, forceH5, playsafe } = result;
            console.log('result', result);

            if (!vid) return;

            this.hasPlayer = true;
            this.$nextTick(() => {
              this.player = polyvObject('#polyv').videoPlayer({
                width: '100%',
                height: '100%',
                forceH5,
                vid
              });
            });
          }
        });
    },
    // 数据类型检测
    type(obj) {
      return Object.prototype.toString.call(obj).slice(8, -1);
    }
  },
  mounted() {
    this._scrollInit = debounce(this.scrollInit, 300, { leading: true });
    this.bindScroll();
  },
  destroyed() {
    this.unbindScroll();
  },
  created() {
    this.query = Object.assign({}, this.query, this.$route.query);
    if (this.query.authorization) {
      setCookies('authkey', this.query.authorization);
    }

    this.kmfSensorsInit(); // 初始化神策统计功能
    this.getActivityInfo(); // 获取活动信息
    this.getClassOutline(); // 获取课程大纲

    if (getCookies('authkey')) {
      this.getParticipateStatus();
    }

    /* // 监听保利威视视频播放状态
    window.s2j_onVideoPause = () => {
      this.bPlaying = false;
    }
    window.s2j_onVideoPlay = () => {
      this.bPlaying = true;
    } */
  },
  filters: {
    formtTime(value) {
      return value < 10 ? '0' + value : value;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #fff;
  .head {
    height: tovw(468);
    position: relative;

    .video-img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      z-index: 9;

      .video-play {
        width: tovw(108);
        height: tovw(108);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: rgba(61, 51, 51, 0.6);
        border-radius: 50%;
        text-align: center;
        line-height: tovw(108);

        .van-icon {
          font-size: tovw(60);
          line-height: tovw(108);
          color: #fff;
        }

        /* &::after {
          content: "►";
          color: #fff;
          font-size: tovw(50);
          display: inline-block;
        } */
      }

      .default-img {
        width: 100%;
        height: 100%;
      }
    }

    .video {
      width: 100%;
      height: 100%;
      object-fit: fill;
      position: relative;
      z-index: 1;
    }
  }
  .main {
    background-color: #fff;
    padding-bottom: tovw(220);

    .main-container {
      padding: 0 tovw(40);

      section {
        padding-top: tovw(50);
      }
    }

    .main-full-container {
      padding: 0;
    }

    .main-head {
      position: relative;
      margin-bottom: tovw(64);

      .main-head-label {
        line-height: tovw(48);
        color: rgba(0, 0, 0, 0.8);
        font-size: tovw(28);

        .s1 {
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
        }
        .s2 {
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          padding: 0 tovw(10);
        }
      }
    }
    .main-date {
      font-size: tovw(28);
      line-height: tovw(48);
      color: rgba(0, 0, 0, 0.6);
      margin-bottom: tovw(24);
    }
    .title {
      font-size: tovw(44);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      line-height: tovw(64);
      padding-top: tovw(48);
      padding-bottom: tovw(8);
    }
    .des {
      font-size: tovw(28);
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.8);
      line-height: tovw(48);
      padding-bottom: tovw(16);
    }
    .count-down {
      margin: tovw(30) 0;
      line-height: tovw(40);
      span {
        text-align: center;
        margin: 0 tovw(6);
        display: inline-block;
        font-size: tovw(28);
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: rgba(0, 0, 0, 0.8);
        line-height: tovw(40);

        &:first-child {
          margin-left: 0;
        }
      }
      .bg {
        min-width: tovw(40);
        height: tovw(40);
        background: url('~@/assets/img/itles-webapp-videoClass/icon-cuontdown.png') no-repeat;
        background-size: 100% 100%;
        color: #fff;
      }
    }
    .caption-list {
      .item {
        display: inline-block;
        padding: 0 tovw(10);
        height: tovw(40);
        background: rgba(108, 57, 200, 0.04);
        border-radius: tovw(8);
        border: 1px solid rgba(108, 57, 200, 0.16);
        font-size: tovw(24);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #987fc5;
        line-height: tovw(40);
        text-align: center;
        margin: 0 tovw(20) tovw(20) 0;
      }
    }
    .tab {
      border-bottom: 1px solid rgba(221, 221, 221, 0.4);
      .tab-nav {
        background-color: #fff;
        li {
          position: relative;
          display: inline-block;
          height: tovw(88);
          width: 33.33%;
          text-align: center;
          line-height: tovw(88);
          a {
            display: block;
            width: 100%;
            height: 100%;
            font-size: tovw(34);
            font-weight: 400;
            color: #a5a5a5;
          }
          span {
            display: none;
            position: absolute;
            width: tovw(48);
            height: tovw(6);
            background: #5f5ddc;
            border-radius: 3px;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        li.active {
          a {
            color: #5f5ddc;
            font-weight: 600;
          }
          span {
            display: block;
          }
        }
      }
    }
  }
}
</style>
